import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "content flex-row-fluid" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Danh mục", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-5" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_10 = { class: "breadcrumb-item text-muted" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-header border-0 pt-2" }
const _hoisted_14 = { class: "card-title d-flex flex-column align-items-start" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder mb-1" }, "Hình thức nộp hồ sơ & thanh toán", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fst-italic" }, "Nội dung mô tả ở đây hiện thẳng cho thí sinh ở cổng nhập học.", -1)
const _hoisted_17 = { class: "filter-slim d-flex flex-wrap align-items-center gap-3 mt-3" }
const _hoisted_18 = { class: "d-flex align-items-center position-relative" }
const _hoisted_19 = { class: "svg-icon svg-icon-3 position-absolute ms-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise me-1" }, null, -1)
const _hoisted_21 = { class: "card-toolbar" }
const _hoisted_22 = {
  class: "justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_23 = { class: "svg-icon svg-icon-2" }
const _hoisted_24 = {
  type: "button",
  class: "btn btn-sm btn-light-primary d-none",
  "data-bs-toggle": "modal",
  ref: "kt_modal_add_combination",
  "data-bs-target": "#kt_modal_add_combination"
}
const _hoisted_25 = { class: "card-body umt-form pt-0" }
const _hoisted_26 = { class: "fw-semibold text-gray-800" }
const _hoisted_27 = { class: "d-flex align-items-center flex-wrap gap-2 mt-1" }
const _hoisted_28 = { class: "text-muted fs-7" }
const _hoisted_29 = {
  key: 0,
  class: "badge badge-light-warning fs-8",
  title: "Bản ghi hệ thống — cổng nhập học đọc theo mã này, không xóa được"
}
const _hoisted_30 = ["title"]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "d-flex flex-center gap-2" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil fs-6" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["disabled", "title", "onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-6" }, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  class: "modal fade",
  id: "kt_modal_add_combination",
  ref: "addCombinationModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_41 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_42 = { class: "modal-content" }
const _hoisted_43 = {
  class: "modal-header py-4 px-6",
  id: "kt_modal_add_customer_header"
}
const _hoisted_44 = { class: "d-flex flex-column" }
const _hoisted_45 = { class: "fw-bolder fs-4 mb-0" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fst-italic mt-1" }, "Mô tả nhập ở đây hiển thị trực tiếp cho thí sinh — soát kỹ số tài khoản, cú pháp nội dung chuyển khoản.", -1)
const _hoisted_47 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_48 = { class: "svg-icon svg-icon-1" }
const _hoisted_49 = { class: "modal-body umt-form py-5 px-6" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center gap-2 pb-2 mb-3 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "1"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-gray-600 text-uppercase" }, "Thông tin hình thức")
], -1)
const _hoisted_51 = { class: "row g-3 mb-4" }
const _hoisted_52 = { class: "col-12 col-lg-5" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Tên", -1)
const _hoisted_54 = { class: "col-6 col-lg-4" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, [
  /*#__PURE__*/_createTextVNode("Mã "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "(hệ thống đọc theo mã)")
], -1)
const _hoisted_56 = { class: "col-6 col-lg-3" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Loại", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center gap-2 pb-2 mb-3 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "2"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-gray-600 text-uppercase" }, "Mô tả hiển thị cho thí sinh")
], -1)
const _hoisted_59 = { class: "mb-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-4" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end gap-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "btn btn-light umt-btn-32",
    "data-bs-dismiss": "modal"
  }, "Hủy"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary umt-btn-32",
    type: "submit"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2 me-1" }),
    /*#__PURE__*/_createTextVNode("Lưu ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ckeditor = _resolveComponent("ckeditor")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
            [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW, _ctx.Permission.DASHBOARD]]
          ]),
          _hoisted_9,
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/caidatthutucnhaphoc",
              class: "text-muted text-hover-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cài đặt thủ tục nhập học ")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-light ms-auto umt-btn-32",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, [
          _hoisted_11,
          _createTextVNode("Quay lại ")
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.applyFilter())),
                  class: "form-control w-250px ps-11",
                  style: {"height":"32px","min-height":"32px","padding-top":"0","padding-bottom":"0","font-size":"13px"},
                  placeholder: "Tìm mã, tên, mô tả..."
                }, null, 544), [
                  [_vModelText, _ctx.search]
                ])
              ]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.filterType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterType) = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.applyFilter())),
                "popper-class": "filter-slim-dd",
                class: "form-select-solid",
                style: {"width":"160px"},
                placeholder: "— Loại —"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "— Loại —",
                    value: ""
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionType, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: _ctx.typeLabel(item),
                      value: item
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.search || _ctx.filterType)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-light",
                    title: "Đặt lại bộ lọc",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.search = ''; _ctx.filterType = ''; _ctx.applyFilter()})
                  }, [
                    _hoisted_20,
                    _createTextVNode("Đặt lại ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.callModalAddApp && _ctx.callModalAddApp(...args)))
              }, [
                _createElementVNode("span", _hoisted_23, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
                ]),
                _createTextVNode(" Thêm hình thức ")
              ]),
              _createElementVNode("button", _hoisted_24, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            total: _ctx.tableData.length,
            currentPage: _ctx.pagination.currentPage,
            "table-header": _ctx.tableHeader,
            "rows-per-page": _ctx.pagination.limit,
            "enable-items-per-page-dropdown": false
          }, {
            "cell-name": _withCtx(({ row: customer }) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(customer.name || '—'), 1),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(customer.code || '—'), 1),
                  (_ctx.isSystemRow(customer))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Hệ thống"))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            "cell-type": _withCtx(({ row: customer }) => [
              _createElementVNode("span", {
                class: _normalizeClass(["badge fs-8", customer.type == 'payment' ? 'badge-light-success' : 'badge-light-primary']),
                title: customer.type
              }, _toDisplayString(_ctx.typeLabel(customer.type)), 11, _hoisted_30)
            ]),
            "cell-description": _withCtx(({ row: customer }) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(["custom-table-editor umt-desc-cell", { 'umt-desc-clamp': !_ctx.expandedRows.includes(customer.id) }]),
                  innerHTML: customer.description
                }, null, 10, _hoisted_31),
                ((customer.description || '').length > 220)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "cursor-pointer text-primary fs-8 fw-semibold",
                      onClick: ($event: any) => (_ctx.toggleRow(customer.id))
                    }, _toDisplayString(_ctx.expandedRows.includes(customer.id) ? 'Thu gọn' : 'Xem thêm'), 9, _hoisted_32))
                  : _createCommentVNode("", true)
              ])
            ]),
            "cell-actions": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-icon btn-light-primary",
                  title: "Chỉnh sửa",
                  onClick: ($event: any) => (_ctx.setDataForm(customer))
                }, _hoisted_36, 8, _hoisted_34),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-icon btn-light-danger",
                  disabled: _ctx.isSystemRow(customer),
                  title: _ctx.isSystemRow(customer) ? 'Bản ghi hệ thống — không xóa được' : 'Xóa hình thức',
                  onClick: ($event: any) => (_ctx.deleteRow(customer))
                }, _hoisted_39, 8, _hoisted_37)
              ])
            ]),
            _: 1
          }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("h2", _hoisted_45, _toDisplayString(_ctx.isEdit ? "Chỉnh sửa hình thức" : "Thêm hình thức"), 1),
              _hoisted_46
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("span", _hoisted_48, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.formData,
              ref: "formRef",
              rules: _ctx.rules
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createVNode(_component_el_form_item, { prop: "name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            class: "form-select-solid w-100",
                            placeholder: "VD: Chuyển khoản",
                            modelValue: _ctx.formData.name,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.name) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createVNode(_component_el_form_item, { prop: "code" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            disabled: _ctx.isEdit && (_ctx.formData.code == 'PAYMENT_BANK_INFO' || _ctx.formData.code == 'PAYMENT_ACCOUNTANT_INFO'),
                            class: "form-select-solid w-100",
                            placeholder: "VD: PAYMENT_BANK_INFO",
                            modelValue: _ctx.formData.code,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.code) = $event))
                          }, null, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createVNode(_component_el_form_item, { prop: "type" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            "popper-class": "umt-form-dd",
                            class: "form-select-solid w-100",
                            modelValue: _ctx.formData.type,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.type) = $event)),
                            filterable: "",
                            "allow-create": "",
                            placeholder: "Chọn hoặc gõ loại mới",
                            "default-first-option": ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionType, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: _ctx.typeLabel(item),
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_58,
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_ckeditor, {
                      editor: _ctx.editor,
                      onReady: _ctx.onReady,
                      modelValue: _ctx.formData.description,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.description) = $event)),
                      config: _ctx.editorConfig
                    }, null, 8, ["editor", "onReady", "modelValue", "config"])
                  ]),
                  _hoisted_60,
                  _hoisted_61
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ])
    ], 512)
  ], 64))
}